export const classes = {
  dialog: 'px-0 py-0 size-[1600px] max-w-[80vw] max-h-[80vh]',
  imgWrapper: 'grow bg-grey-9 size-full place-center',
  img: 'max-w-full max-h-full',
};
